// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3x_z8","colMaxWidth":"Table_colMaxWidth__mVnw0"};